import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { postRestRequest } from 'src/helpers/RestHelpers'
import { ClassifiedAnswer } from 'src/rest/types/Classified'

export type SeenAnswerResponse = SimpleResult<ClassifiedAnswer>

export type SeenAnswerParams = {
  answerId: string
}

const seenAnswer = ({ answerId }: SeenAnswerParams) => {
  return postRestRequest({
    url: `${api.REST_API_URL}/classified-answers/mark-seen`,
    data: {
      answerId,
    },
    transformer: (data: SeenAnswerResponse) => {
      return data
    },
  })
}
export default seenAnswer
